import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import TabHeader from "../../tab/TabHeader"
import NotesControls from "./NotesControls"
import NotesDetails from "./NotesDetails"
import { notesActions } from "../../../../store/notes"
import { detailsActions } from "../../../../store/details"

const NotesTab = ({ inWorkQ }) => {
    const dispatch = useDispatch()
    const caseId = useSelector(state => state.case.activeCase?.case?.id)
    const [showDeleted, setShowDeleted] = useState(false)

    useEffect(() => {
        setShowDeleted(false)
    }, [caseId])

    useEffect(() => {
        return () => {
            dispatch(notesActions.setFilterResult(null))
            dispatch(detailsActions.setNotesType(null))
        }
    }, [])

    return <div >
        <TabHeader>
            <h2>Notes</h2>
            <NotesControls showDeleted={showDeleted} onShowDeletedChange={setShowDeleted} />
        </TabHeader>        
        <NotesDetails showDeleted={showDeleted} />        
    </div>
}

export default NotesTab